export default "__VITE_ASSET__6bf2c3bb__"